<template>
  <div id="booking-summary__sidebar">
    <div class="booking-summary__intro" @click="$emit('toggle-summary')">
      <div class="filter__toggle--slide">
        <div class="arrow arrow--right"></div>
      </div>
      <div class="intro-label">
        <b class="sans-serif">Zusammenfassung</b><br />
        <span>Klicken Sie auf einen Bereich um eine Änderung Ihres Reisewunsches vorzunehmen:</span>
      </div>
    </div>
    <div class="booking-summary__subsection" v-for="section in summary" @click="stepBackTo(section.section)">
      <div class="booking-summary__title">
        {{ $t(`booking.sectionTitles.${section.section}`) }}
      </div>
      <ul class="booking-summary__infos">
        <li class="sans-serif" v-for="info in section.infos">{{info}}</li>
      </ul>
    </div>
    <div class="booking-summary__price sans-serif" v-if="currentPrice">
      <b>{{ currentPrice}} EUR</b>
      <br />
      Gesamtpreis für alle Reiseteilnehmer
    </div>
  </div>
</template>

<script>

export default {
  props: {
    summary: {
      type: Array,
      default: []
    },
    currentPrice: {
      type: String,
      default: null
    }
  },
  methods: {
    stepBackTo(step){
      this.$emit('section-clicked', step)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
        <div class="arrow arrow--right"></div>
      </div>
      <div class="intro-label">
        <b class="sans-serif">Zusammenfassung</b><br />
        <span>Klicken Sie auf einen Bereich um eine Änderung Ihres Reisewunsches vorzunehmen:</span>
      </div>
    </div>
    <div class="booking-summary__subsection" v-for="section in summary" @click="stepBackTo(section.section)">
      <div class="booking-summary__title">
        <img src="/images/icons_svg/edit-icon.svg" class="svg-icon"></img>
        {{section.name}}
      </div>
      <ul class="booking-summary__infos">
        <li class="sans-serif" v-for="info in section.infos">{{info}}</li>
      </ul>
    </div>
    <div class="booking-summary__price sans-serif" v-if="currentPrice">
      <b>{{ currentPrice}} EUR</b>
      <br />
      Gesamtpreis für alle Reiseteilnehmer
    </div>
  </div>
</template>

<script>

export default {
  props: {
    summary: {
      type: Array,
      default: []
    },
    currentPrice: {
      type: String,
      default: null
    }
  },
  methods: {
    stepBackTo(step){
      this.$emit('section-clicked', step)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>